
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/alojamientos",
      function () {
        return require("private-next-pages/[region]/[resort]/alojamientos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/alojamientos"])
      });
    }
  